var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.533 0A.533.533 0 0 0 0 .533v14.934A.533.533 0 0 0 .533 16H4.8a.533.533 0 0 0 .533-.533V5.333h10.134A.533.533 0 0 0 16 4.8V.533A.533.533 0 0 0 15.467 0H.533Zm.534 4.347v-3.28h3.28v3.28h-3.28Zm0 .906v9.68h3.2v-1.146H2.933a.453.453 0 0 1 0-.907h1.334v-1.227H2.4a.453.453 0 1 1 0-.906h1.867V9.52H2.933a.453.453 0 1 1 0-.907h1.334V7.387H2.933a.453.453 0 1 1 0-.907h1.334V5.253h-3.2Zm4.186-.986H6.48V2.933a.453.453 0 1 1 .907 0v1.334h1.226V2.933a.453.453 0 0 1 .907 0v1.334h1.227V2.4a.453.453 0 1 1 .906 0v1.867h1.227V2.933a.453.453 0 0 1 .907 0v1.334h1.146v-3.2h-9.68v3.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgArea;